import { initializeStatistics, removeEventListeners } from 'Utils/statistics/active_hrs_stats'
import { useEffect } from 'react'
import Chip from '@mui/material/Chip'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import { Dropdown, Nav } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { logout } from 'Store/UserInfo/Actions'
import { useDispatch } from 'react-redux'

const ProfileButton = ({email, username}) => {

  const dispatch = useDispatch()
  useEffect(
    ()=> {
      initializeStatistics()
      return removeEventListeners
    },[]
  )

  return (
    <Dropdown
      as={Nav}
    >
      <Dropdown.Toggle
        className = 'px-2'
        as = {Chip}
        icon={<AccountCircleIcon />} 
        label={username ? username : email}
        variant='outlined'
      />
      <Dropdown.Menu>
        <Dropdown.Item
          as={Link}
          to='/profile'
        >
          Profile
        </Dropdown.Item>
        <Dropdown.Item
          as={Link}
          to='/'
          onClick={async () => await dispatch(logout())}
        >
          Logout
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}
export default ProfileButton